export default [
    {
        name: 'English',
        locale: 'en',
        country: 'us',
        code: 'en',
        fallback: true,
        available: true
    },
    {
        name: 'Français',
        locale: 'fr-FR',
        country: 'fr',
        code: 'fr',
        available: true
    },
    {
        name: 'Español',
        locale: 'es-ES',
        country: 'es',
        code: 'es',
        available: true
    }
];
